import { ReactNode } from "react";
import { cn } from "~/lib/utils";

interface SectionHeadingProps {
  title: ReactNode;
  /** Control pinned to the right of the rule — an Edit button, a "view all" link. */
  action?: ReactNode;
  className?: string;
}

/**
 * Section label with a rule running out to a trailing action
 * ("Description ———— Edit"). The rule separates, so the block needs no card.
 */
export function SectionHeading({ title, action, className }: SectionHeadingProps) {
  return (
    <div className={cn("flex min-h-8 items-center gap-3", className)}>
      <h2 className="shrink-0 text-sm font-medium text-muted-foreground">{title}</h2>
      <span className="h-px min-w-4 flex-1 bg-border" aria-hidden="true" />
      {action}
    </div>
  );
}
